import * as Yup from 'yup';
import { LanguagesType } from 'App/i18n';

export const isValidVideoUrl =
  /^(https:\/\/(www.youtube.*|www.vimeo.*|youtu.*|vimeo.*))?$/;

export const isSecureUrl = /^(https:\/\/.*|)$/;

/**
 * Normalizes a string by removing diacritics and converting to lowercase
 * for case-insensitive and accent-insensitive comparison
 */
export const normalizeString = (str: string): string =>
  str
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();

export const buildProductSchema = (
  languages: LanguagesType[],
  fullValidateVideoUrl = true,
): Yup.AnyObjectSchema =>
  Yup.object().shape({
    name: Yup.object().shape({
      ...languages.reduce(
        (acc, current) => ({
          ...acc,
          [current]: Yup.string().trim().required('products.errorName'),
        }),
        {},
      ),
    }),
    videoUrl: (fullValidateVideoUrl
      ? Yup.string().matches(isValidVideoUrl, 'products.errorVideoUrl')
      : Yup.string().matches(isSecureUrl, 'products.errorVideoUrl')
    ).nullable(),
    tags: Yup.array()
      .of(Yup.string().trim().required('products.errorTags'))
      .test(
        'no-duplicate-tags',
        'products.errorTagsDuplicate',
        function (tags) {
          if (!tags || tags.length === 0) return true;

          const normalizedTags = new Set<string>();
          for (let i = 0; i < tags.length; i++) {
            const tag = tags[i];
            if (!tag) continue;
            const normalized = normalizeString(tag.trim());
            if (normalizedTags.has(normalized)) {
              return false;
            }
            normalizedTags.add(normalized);
          }
          return true;
        },
      ),
  });
